import { Tooltip } from 'antd'
import { Icon } from '@iconify/react'
import { Droppable } from 'react-beautiful-dnd'

import { cellId, getColumnBandClass } from '../utils'
import StoryCard from './StoryCard'
import styles from '../../ProjectStoryMapBoard.module.css'

const StoryCell = ({
    release,
    step,
    trackIndex,
    boardTracks,
    onAddStory,
    onOpenStory,
    editingStoryId,
    editingStoryDraft,
    storyInputRef,
    onStoryDraftChange,
    onCommitStoryTitle,
    storyMenu,
    highlightedCardId,
    isFilterActive = false,
    filterFocusedCardId = null,
    isPointerDropTarget = false,
    isStoryDragging = false,
    readOnly = false,
}) => {
    const stories = release.stories.filter(
        (story) => String(story.stepId) === String(step.id)
    )
    const bandClass = getColumnBandClass(boardTracks, trackIndex, styles)
    const showDropTarget = isStoryDragging && isPointerDropTarget

    return (
        <div
            key={`${release.id}-${step.id}`}
            className={`${styles.stepColumn} ${bandClass}`}
            data-story-map-cell="true"
            data-story-map-release-id={String(release.id)}
            data-story-map-step-id={String(step.id)}
        >
            <Droppable droppableId={cellId(release.id, step.id)} type="STORY">
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`${styles.storyCell} ${
                            showDropTarget ||
                            (isStoryDragging && snapshot.isDraggingOver)
                                ? styles.storyCellOver
                                : ''
                        } ${stories.length === 0 ? styles.storyCellEmpty : ''}`}
                        data-story-map-droppable-cell="true"
                        data-story-map-release-id={String(release.id)}
                        data-story-map-step-id={String(step.id)}
                    >
                        <div className={styles.storyStack}>
                            {stories.map((story, storyIndex) => (
                                <StoryCard
                                    key={story.id}
                                    story={story}
                                    storyIndex={storyIndex}
                                    isEditing={editingStoryId === story.id}
                                    editDraft={
                                        editingStoryId === story.id
                                            ? editingStoryDraft
                                            : ''
                                    }
                                    titleInputRef={
                                        editingStoryId === story.id
                                            ? storyInputRef
                                            : null
                                    }
                                    onDraftChange={onStoryDraftChange}
                                    onCommitTitle={onCommitStoryTitle}
                                    onOpen={onOpenStory}
                                    storyMenu={storyMenu}
                                    isHighlighted={
                                        String(highlightedCardId) === String(story.id)
                                    }
                                    isFilterActive={isFilterActive}
                                    isFilterMatchCurrent={
                                        String(filterFocusedCardId) === String(story.id)
                                    }
                                    readOnly={readOnly}
                                />
                            ))}
                            {provided.placeholder}
                            {showDropTarget ? (
                                <div className={styles.storyDropHint} aria-hidden>
                                    Drop here
                                </div>
                            ) : null}
                        </div>
                        {!readOnly && !isFilterActive && stories.length === 0 && (
                            <button
                                type="button"
                                className={styles.addStoryLink}
                                onClick={() => onAddStory(release.id, step.id)}
                            >
                                <Icon icon="mdi:plus" width={14} />
                                Add story
                            </button>
                        )}
                        {!readOnly && !isFilterActive && stories.length > 0 && (
                            <Tooltip title="Add story" placement="bottom">
                                <button
                                    type="button"
                                    className={styles.addStoryInline}
                                    onClick={() => onAddStory(release.id, step.id)}
                                    aria-label="Add story"
                                >
                                    <Icon icon="mdi:plus" width={12} />
                                </button>
                            </Tooltip>
                        )}
                    </div>
                )}
            </Droppable>
        </div>
    )
}

export default StoryCell
